module.exports = __webpack_public_path__ + "img/insightful.43b01499.svg";